import type { NavIconName } from '@/app/routes';
import {
  ContestsIcon,
  FixturesIcon,
  HomeIcon,
  LeaderboardIcon,
  LeaguesIcon,
  PointsIcon,
  ProfileIcon,
  TeamIcon,
  TransfersIcon,
  type NavIconProps,
} from './NavIcons';

export * from './NavIcons';

/** Resolves a nav item's icon name to the component that draws it. */
export const NAV_ICONS: Record<NavIconName, (props: NavIconProps) => React.JSX.Element> = {
  home: HomeIcon,
  team: TeamIcon,
  contests: ContestsIcon,
  fixtures: FixturesIcon,
  leagues: LeaguesIcon,
  leaderboard: LeaderboardIcon,
  points: PointsIcon,
  profile: ProfileIcon,
};

export { TransfersIcon };
